export const environment = {
  dev: false,
  cookieDomain: 'zammy.ai',
  domain: 'https://sid.zammy.ai',
  google: {
    clientId: '4197249581-c3p4jb9hpmti89adtjpuofmj8c6f5ad5.apps.googleusercontent.com',
    clientSecret: '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',
  },
  grapqhl: {
    uri: 'https://marketplaceapi.scattre.co',
  },
};
